import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { focusElemnt } from '../../../../common/helper'
import moment from 'moment'

const ReportTable = (props) => {
    const { reportData,coloumndef=0 } = props

    const [tableData, setTableData] = useState([])
    const [searchData, setSearchData] = useState({
        CompanyName: "",
        BranchName: "",
        Cityname: "",
        Statename: "",
        ChargeTypeName: "",
        RangeMin: "",
        RangeMax: "",
        Charge: "",
        UserName: "",
    })
    const columnDefs = [
        { headerName: 'SN', field: "", headerSx: { minWidth: "20px", textAlign: 'right' }, showfilter: false },
        { headerName: 'Company Name', field: "CompanyName", headerSx: { minWidth: "200px" }, showfilter: true },
        { headerName: 'Branch Name', field: "BranchName", headerSx: { minWidth: "190px" }, showfilter: true },
        { headerName: 'City Name', field: "Cityname", headerSx: { minWidth: "107px" }, showfilter: true },
        { headerName: 'State Name', field: "Statename", headerSx: { minWidth: "100px" }, showfilter: true },
        { headerName: 'Charge Type', field: "ChargeTypeName", headerSx: { minWidth: "90px" }, showfilter: true },
        { headerName: 'Range Min.', field: "RangeMin", headerSx: { minWidth: "84px",textAlign:'right' }, showfilter: true },
        { headerName: 'Range Max.', field: "RangeMax", headerSx: { minWidth: "106px",textAlign:'right' }, showfilter: true },
        { headerName: 'Charge', field: "Charge", headerSx: { minWidth: "84px",textAlign:'right' }, showfilter: true },
        { headerName: 'Modified By', field: "UserName", headerSx: { minWidth: "106px" }, showfilter: true },
        { headerName: 'Modified Date & Time', field: "ModifiedDate", headerSx: { minWidth: "140px" }, showfilter: false },
        { headerName: 'Status', field: "", headerSx: { minWidth: "60px" }, showfilter: false },
    ]
    const columnDefs2 = [
        { headerName: 'SN', field: "", headerSx: { minWidth: "20px", textAlign: 'right' }, showfilter: false },
        { headerName: 'Branch \nName', field: "BranchName", headerSx: { minWidth: "190px" }, showfilter: true },
        { headerName: 'City \nName', field: "Cityname", headerSx: { minWidth: "107px" }, showfilter: true },
        { headerName: 'Charge \nType', field: "ChargeTypeName", headerSx: { minWidth: "90px" }, showfilter: true },
        { headerName: 'Range Per \nKg Min.', field: "RangeMin", headerSx: { minWidth: "84px" }, showfilter: true },
        { headerName: 'Range Per \nKg Max.', field: "RangeMax", headerSx: { minWidth: "106px" }, showfilter: true },
        { headerName: 'Range Per \nKm Min.', field: "RangeMin", headerSx: { minWidth: "84px" }, showfilter: true },
        { headerName: 'Range Per \nKm Max.', field: "RangeMax", headerSx: { minWidth: "106px" }, showfilter: true },
        { headerName: 'Charge \nPer Kg', field: "Charge", headerSx: { minWidth: "84px" }, showfilter: true },
        { headerName: 'Add. Chrg. \nPer Unit', field: "Charge", headerSx: { minWidth: "84px" }, showfilter: true },
        { headerName: 'Modified \nBy', field: "UserName", headerSx: { minWidth: "106px" }, showfilter: true },
        { headerName: 'Modified Date \n& Time', field: "ModifiedDate", headerSx: { minWidth: "140px" }, showfilter: false },
        { headerName: 'Status', field: "", headerSx: { minWidth: "60px" }, showfilter: false },
    ]
    const tableCloumns = coloumndef===0?columnDefs:columnDefs2;
    useEffect(() => {
        setTableData(sortingData(reportData))
        setSearchData({
            CompanyName: "",
            BranchName: "",
            Cityname: "",
            Statename: "",
            ChargeTypeName: "",
            RangeMin: "",
            RangeMax: "",
            Charge: "",
            UserName: "",
        })
    }, [reportData])
    const sortingData = (data) => {
        return data.sort((a, b) => a.CompanyName.localeCompare(b.CompanyName)).sort((a, b) => a.BranchName.localeCompare(b.BranchName)).sort((a, b) => a.Cityname.localeCompare(b.Cityname))
    }
    const keyboardNavigation = (event, prevId, nextId) => {
        if (event.key === 'Escape') {
            focusElemnt(prevId)
        }
        if (event.key === 'Enter') {
            focusElemnt(nextId)
        }
    }
    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value.toString() })
    }
    useEffect(() => {
        let fiterData = reportData.filter((val) => (searchData.BranchName === "" || val.BranchName.toLowerCase().includes(searchData.BranchName.toLowerCase())) &&
            (searchData.Cityname === "" || val.Cityname.toLowerCase().includes(searchData.Cityname.toLowerCase())) &&
            (searchData.CompanyName === "" || val.CompanyName.toLowerCase().includes(searchData.CompanyName.toLowerCase())) &&
            (searchData.Statename === "" || val.Statename.toLowerCase().includes(searchData.Statename.toLowerCase())) &&
            (searchData.ChargeTypeName === "" || val.ChargeTypeName.toLowerCase().includes(searchData.ChargeTypeName.toLowerCase())) &&
            (searchData.RangeMin === "" || val.RangeMin.toString().includes(searchData.RangeMin.toString())) &&
            (searchData.RangeMax === "" || val.RangeMax.toString().includes(searchData.RangeMax.toString())) &&
            (searchData.Charge === "" || val.Charge.toString().includes(searchData.Charge.toString())) &&
            (searchData.UserName === "" || val.UserName.toLowerCase().includes(searchData.UserName.toLowerCase()))
        )
        setTableData(fiterData)
    }, [searchData])

    const TableRow1 = ({ val, index }) => {
      return (
        <TableRow key={`DR-${index}`}>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{index + 1}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '200px' }}>
            {val.CompanyName}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '190px' }}>
            {val.BranchName}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '107px' }}>
            {val.Cityname}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '100px' }}>
            {val.Statename}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ChargeTypeName}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMin}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMax}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.Charge}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '106px' }}>
            <Tooltip
              title={`${val.UserName}(${val.UserBranch})`}
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: '#DAEDFE',
                    color: '#000',
                    minHeight: '26px',
                    display: 'flex',
                    fontWeight: '400',
                    alignItems: 'center',
                    marginTop: '5px !important',
                    fontSize: '12px',
                  },
                },
              }}
              placement="bottom-start"
            >
              <span
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'block',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
                onMouseOut={(e) => (e.currentTarget.style.color = '#444')}
                onMouseOver={(e) => (e.currentTarget.style.color = '#0086FF')}
              >
                {val.UserName}
              </span>
            </Tooltip>
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
            {moment(val.ModifiedDate).format('HH:mm, DD-MMM-YY')}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
            <Checkbox checked={val.IsActive == 1 ? true : false} sx={{ padding: 0 }} />
          </TableCell>
        </TableRow>
      )
    }
    const TableRow2 = ({ val, index }) => {
      return (
        <TableRow key={`DR-${index}`}>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{index + 1}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '190px' }}>
                                {val.BranchName}
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '107px' }}>
                                {val.Cityname}
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', }}>{val.ChargeTypeName}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMin}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMax}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMin}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMax}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.Charge}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.Charge}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '106px' }}>
                                <Tooltip title={`${val.UserName}(${val.UserBranch})`}
                                    PopperProps={{
                                        sx: {
                                            "& .MuiTooltip-tooltip": {
                                                backgroundColor: '#DAEDFE',
                                                color: "#000",
                                                minHeight: '26px',
                                                display: 'flex',
                                                fontWeight: '400',
                                                alignItems: "center",
                                                marginTop: '5px !important',
                                                fontSize: '12px'
                                            }
                                        }
                                    }}
                                    placement="bottom-start">
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: "underline" }}
                                        onMouseOut={(e) => e.currentTarget.style.color = '#444'}
                                        onMouseOver={(e) => e.currentTarget.style.color = '#0086FF'}
                                    >
                                        {val.UserName}
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', }}>{moment(val.ModifiedDate).format("HH:mm, DD-MMM-YY")}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                                <Checkbox
                                    checked={val.IsActive == 1 ? true : false}
                                    sx={{ padding: 0, }}
                                />
                            </TableCell>
                        </TableRow>
      )
    }
    return (
      <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '60vh', marginBottom: '5px' }}>
        <Table
          stickyHeader
          size="small"
          aria-label="a dense table"
          sx={{
            '& .MuiTableCell-root': {
              padding: '6px 8px !important',
            },
          }}
        >
          <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
            <TableRow>
              {tableCloumns.map((col, index) => (
                <TableCell
                  key={`TH-${index}`}
                  sx={{
                    ...col.headerSx,
                    backgroundColor: '#DAEDFE',
                    minHeight: '40px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#444',
                  }}
                >
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {tableCloumns.map((col, index) =>
                col.showfilter ? (
                  <TableCell key={`FTH-${index}`} sx={{ minHeight: '36px' }}>
                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                      <input
                        id={`index-${index}`}
                        className="field"
                        name="cancelSearchInput"
                        style={{ width: '100%' }}
                        value={searchData[col.field]}
                        placeholder="Contains"
                        onChange={(e) => handleSearchData(e, col.field)}
                        onKeyDown={(e) =>
                          keyboardNavigation(
                            e,
                            index === 1 ? 'editExisting' : `index-${index - 1}`,
                            index === 9 ? 'Select_Charge' : `index-${index + 1}`
                          )
                        }
                      />
                      <FilterAltIcon sx={{ paddingRight: '0px !important' }} />
                    </div>
                  </TableCell>
                ) : (
                  <TableCell></TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((val, index) => {
             return  coloumndef === 0 ? <TableRow1 val={val} index={index} /> : <TableRow2 val={val} index={index} />
              
            })}
            
          </TableBody>
        </Table>
      </TableContainer>
    )
}

export default ReportTable